import {
    getVlinkGuidesList,
    deleteVLinkGuide,
    queryTagTreesData,
    updateMaterialTagTrees,
    deleteMaterialTagTrees,
    addMaterialTagTrees,
    moveMaterialTagTrees,
    queryTglStrategy,
    queryGicpStrategy,
    queryVLinkVideo,
    queryZhiJiPicture
} from "@/views/zhiji/js/services/service.js";

import i18n from "@/i18n";

export default {
    state: {
        treeData: {},
        classifyData: [],
        queryClassify: {},
        classifyTotal: 0,
        queryNotClassify: {},
        videoData: [],
        queryConditions: {},
        total: 0,
        pictureTotal: 0,
        pictureData: []
    },
    mutations: {
        tagTreesData(state, dataList) {
            let newDatas = {
                label: i18n.t("zhiji.common.allClassify"),
                id: "-1",
                smallLabel: "",
                children: dataList
            };
            state.treeData = newDatas;
        },
        updataClassifyData(state, dataList) {
            state.classifyTotal = dataList.count;
            state.classifyData = dataList.strategyData;
        },
        updateQueryClassify(state, data) {
            state.queryClassify = Object.assign({}, state.queryClassify, data);
        },
        updataVideoList(state, dataList) {
            state.total = dataList.count;
            state.videoData.splice(0, state.videoData.length, ...dataList.videoData);
        },
        updateQueryConditions(state, data) {
            state.queryConditions = Object.assign({}, state.queryConditions, data);
        },
        updataPictureList(state, dataList) {
            state.pictureTotal = dataList.count;
            state.pictureData.splice(0, state.pictureData.length, ...dataList.pictureData);
        }
    },
    actions: {
        queryTagTreesList(context, param) {
            queryTagTreesData(param).then(function(dataList) {
                context.commit("tagTreesData", dataList);
            });
        },
        addMaterialTagTrees(context, param) {
            addMaterialTagTrees(param).then(function(result) {
                result === "success" ? context.dispatch("queryTagTreesList", {}) : "";
            });
        },
        updateMaterialTagTrees(context, param) {
            updateMaterialTagTrees(param).then(function(result) {
                result === "success" ? context.dispatch("queryTagTreesList", {}) : "";
            });
        },
        deleteMaterialTagTrees(context, param) {
            deleteMaterialTagTrees(param).then(function(result) {
                result === "success"
                    ? context.dispatch("queryTagTreesList", {})
                    : context.dispatch("showModal", {
                          type: "MessageModal",
                          data: {
                              type: "error",
                              message: result.errMessage
                          }
                      });
            });
        },
        moveMaterialTagTrees(context, param) {
            moveMaterialTagTrees(param).then(function(result) {
                context.dispatch("queryTagTreesList", {});
            });
        },
        queryGuidesList(context, param) {
            param && context.commit("updateQueryClassify", param);
            getVlinkGuidesList(context.state.queryClassify).then(function(data) {
                context.commit("updataClassifyData", data);
            });
        },
        deleteVLinkGuide(context, param) {
            deleteVLinkGuide(param).then(function(data) {
                context.dispatch("queryGuidesList");
            });
        },
        queryVideoList(context, param) {
            param && context.commit("updateQueryConditions", param);
            queryVLinkVideo(context.state.queryConditions).then(function(data) {
                context.commit("updataVideoList", data);
            });
        },
        queryPictureList(context, param) {
            param && context.commit("updateQueryConditions", param);
            queryZhiJiPicture(context.state.queryConditions).then(function(data) {
                context.commit("updataPictureList", data);
            });
        }
    }
};
